import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import type { SchedulingFlowInitialData } from "@leagueplatform/care-finder";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";
import { requestSchedulingFlowOpen } from "utils/scheduling-flow/scheduling-flow-bridge";

const toInitialData = (search: string): SchedulingFlowInitialData =>
  Array.from(new URLSearchParams(search).entries()).map(([key, value]) => ({
    key,
    value,
  }));

export const SchedulingFlowLauncher = () => {
  const navigate = useNavigate();
  const { search, key } = useLocation();

  useEffect(() => {
    requestSchedulingFlowOpen(key, toInitialData(search));
    navigate(APP_MANAGED_ROUTES.SCREENINGS, { replace: true });
  }, [navigate, search, key]);

  return null;
};
